module.exports = __webpack_public_path__ + "static/media/03-longo.a8d56d53.svg";